<template>
<div class="employees-widget" @click.stop='openLink'>
  <div class="employees-widget__title">
    <div class="employees-widget__title__label">{{this.$t('dashboard.employees.label')}}</div>
    <div class="employees-widget__title__date"> {{formattedDate}} </div>
  </div>
  <div class="employees-widget__row">
    <information-widget-cell
      :value="actualFormatted.toString()"
      title="dashboard.employees.actual"
    />
    <information-widget-cell
      :value="`${leakedFormatted.toString()} / ${clearTextFormatted.toString()}`"
      title="dashboard.employees.Leaked.passwords"
      fit-to-width
    />
  </div>
  <v-divider />
  <div class="employees-widget__row">
    <delta-widget-cell
      :value="delta"
    />
    <delta-widget-cell
      :value="verified"
      title="dashboard.employees.verified.emails"
      :trend='false'
      :no-data='noData'
    />
  </div>
</div>
</template>

<script>
import moment from 'moment';
import DeltaWidgetCell from '@/components/Dashboard/DeltaWidgetCell.vue';
import InformationWidgetCell from '@/components/Dashboard/InformationWidgetCell.vue';

export default {
  name: 'EmployeesWidget',
  props: {
    actual: Number,
    clearText: Number,
    leaked: Number,
    verified: Number,
    delta: Number,
    date: Date,
    url: {
      required: false,
    },
    noData: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    DeltaWidgetCell,
    InformationWidgetCell,
  },
  methods: {
    openLink() {
      if (this.url) {
        this.$router.push(this.url);
      }
    },
  },
  computed: {
    actualFormatted() {
      return this.noData ? this.$t('no.data.dashboard.stats') : this.actual;
    },
    leakedFormatted() {
      return this.noData ? this.$t('no.data.dashboard.stats') : this.leaked;
    },
    clearTextFormatted() {
      return this.noData ? this.$t('no.data.dashboard.stats') : this.clearText;
    },
    formattedDate() {
      return moment(this.date).format('D MMM yyyy');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.employees-widget {
  display: flex;
  flex-direction: column;
  max-width: rem(320);
  min-width: rem(320);
  min-height: rem(213);
  background-color: var(--bg-secondary);
  border-radius: $radius-md;
  &__title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: rem(20) rem(25) 0;
    &__label{
      color: var(--text-secondary);
      font-family: $font-family-regular;
      font-size: rem(12);
      letter-spacing: rem(1.1);
      line-height: rem(15);
    }
    &__date{
      color: var(--text-muted);
      font-family: $font-family-regular;
      font-size: rem(12);
      letter-spacing: 0;
      line-height: rem(15);
      text-align: right;
    }
  }
  &__row{
    display: flex;
    flex-direction: row;
    justify-content: left;
    padding: rem(15) rem(25) rem(15);
    margin-top: rem(6);
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
<style lang="scss">
@import '~@/assets/styles/design-system';
.employees-widget {
  .v-divider {
    margin-left: rem(25) !important;
    margin-right: rem(25) !important;
    margin-top: 0px;
  }
}
</style>
